<template>
   <div class="shangquanpingjiaPage" @touchstart="touchEvent" 
    @touchmove="touchEvent" 
    @touchend="touchEvent" 
    @scroll="touchEvent">
      <div class="xr-mingxi">        
        <mu-appbar class="xr-head" :title="storeInfo.CompanyName">
          <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
          <mu-icon-button @click="FavStore()" icon=":fa fa-xing1" v-if="!favState" slot="right"/>
          <mu-icon-button @click="UnFavStore()" icon=":fa fa-star" class="unFav" v-if="favState" slot="right"/>
          <!-- <mu-icon value=":fa fa-zhuanfa" :size="20" slot="right"/> -->
        </mu-appbar>
    </div>
    <mu-list class="productPingfen">    
       <div class="productBanner">
          <XR-swiper ref="swiper" :showIndic="true">
            <XR-slide v-for="(imgItem,index) in storeInfo.Images" :key="index">
              <img :src="imgItem" />
            </XR-slide>
          </XR-swiper>   
      </div>
        <mu-list-item class="proList">
            <div class="star-leval">
                <p class="storeName" style="font-size: 18px;">{{storeInfo.CompanyName}}</p>
                <p class="fiveStar">
                  <mu-icon value=":fa fa-star"  slot="left" v-for="sIndex in storeInfo.StarLevel" :key="sIndex" />
                  <mu-icon value=":fa fa-star" class="empty_satr" slot="left" v-for="sIndex in (5-storeInfo.StarLevel)" :key="sIndex"/>
                  <span style="padding-left: 3%; color: rgb(244, 67, 54); font-size: 14px; width:15%;">{{storeInfo.StarLevel}}分</span>
                  <span class="pjPrice">人均<span style="font-size:12px; color: red;">￥</span> 
                    <span style="color:red; font-weight:bold;font-size:17px;">{{storeInfo.AverageConsumption}}</span>
                </span>
                </p>
                
            </div>
        </mu-list-item>
        <mu-list-item class="duce">
            <div class="zuo">
                <p style="height:25px;display:flex; align-items: center; line-height: 25px;">
                  <mu-icon value=":fa fa-naozhong" :size="14"/>
                  <span style="padding-left:5px; color: #999;font-size:12px;">营业时间 {{storeInfo.OpenTime}}</span>
                </p> 
                  <template v-for="serviceItem in storeInfo.ServiceList">
                    <div class="img_pro">
                      <mu-icon :value="':'+serviceItem.Value" :size="20" :key="serviceItem.Id" v-if="serviceItem.TypeId==1" />
                      <img :src="serviceItem.Value" :key="serviceItem.Id" class="serviceImg"  v-if="serviceItem.TypeId==2" />
                      <p class="pro_server">{{serviceItem.Name}}</p>
                    </div>
                  </template>
              
            </div>
        </mu-list-item>
        
    </mu-list>  
    <mu-list class="love">
        <mu-list-item  title="商家信息" class="proList1">
          <mu-icon slot="left" value=":fa fa-myhome" :size="16" />
          <mu-icon-button slot="right" icon=":fa fa-angle-right" :size="20" color="#999" :to="'/shangquan/zizhi?shopId='+storeInfo.ShopId"></mu-icon-button>    
        </mu-list-item>
        <!-- <mu-list-item  class="address" v-show="show">
          <div class="dinwei">
            <p>
              <mu-icon  value=":fa fa-mydinwei" :size="16" />
              <span style="padding-left:5px; color: #999;">武汉黄鹤楼对面一楼</span>
            </p>
            <p>
              <mu-icon  value=":fa fa-phone2" :size="14" />
              <span style="padding-left:5px; color: #999;">027-848848484</span>
            </p>
          </div>   
          <div class="phone1">
              <mu-icon  value=":fa fa-phone1" :size="30" color="rgb(244, 67, 54)" />
          </div>
        </mu-list-item>
        <mu-list-item  class="address" v-show="show">
          <div class="dinwei">
            <p>
              <mu-icon  value=":fa fa-mydinwei" :size="16" />
              <span style="padding-left:5px; color: #999;">江汉路武商摩尔城负一楼</span>
            </p>
            <p>
              <mu-icon  value=":fa fa-phone2" :size="14" />
              <span style="padding-left:5px; color: #999;">027-848848484</span>
            </p>
          </div>   
          <div class="phone1">
              <mu-icon  value=":fa fa-phone1" :size="30" color="rgb(244, 67, 54)" />
          </div>
        </mu-list-item>
        <mu-list-item  class="tmbtn" style="text-align: center;">
            <mu-flat-button @click="show=!show" label="其他门店" class="demo-flat-button" labelPosition="before" :icon="':fa fa-angle-' + (show===false?'down':'up')"  secondary  />
        </mu-list-item> -->
        <mu-list-item  class="zhekou" v-if="storeInfo.IsDiscount>0">
          <div  style="width:13%; align-items: center;display: flex;">
            <div class="sale_circle">付</div>
              <!-- <img  src=" ../static/shangquan/付.png" alt=""> -->
          </div>         
          <div v-if="storeInfo.IsDiscount == 1">
            <p>{{storeInfo.SaleDiscount}}折</p>
            <p style="color:#999;">{{storeInfo.OpenTime}}使用</p>
          </div>         
          <div v-if="storeInfo.IsDiscount == 2">
            <p>{{candyCname}}抵扣</p>
            <p style="color:#999;">{{storeInfo.OpenTime}}使用</p>
          </div>
        </mu-list-item>
        <!-- <mu-list-item  class="proList">
            <div class="temai">
              <img  src=" ../static/shangquan/特.png" alt="">
              <span style="padding-left: 13px; color: #999;">特卖商品</span>
            </div>
        </mu-list-item>
        <mu-list-item class="product">
          <div class="product-item">
            <router-link to="">
            <img src=" ../static/shangquan/1.png" class="pro-img"> 
            <div class="product-info" :style="{ width:proItemInfoWidth+'px'}"><p class="product-name">莫尔根海鲜自助火锅</p> 
                <div class="saleinfo">
                  <p class="price"><i class="fa fa-rmb"></i>53.9 <i style="font-size: 12px;color:#ccc;text-decoration:line-through;"><i class="fa fa-rmb" style="font-size:12px; margin:0px;"></i>69</i></p>
                  <p class="saleCount"><span style="color: #ccc;font-size:12px;">已售2331</span></p>
                </div>
              </div>
            </router-link>
          </div>
        </mu-list-item>
        <mu-list-item class="product">
          <div class="product-item">
              <router-link to="">
              <img src=" ../static/shangquan/2.png" class="pro-img"> 
              <div class="product-info" :style="{ width:proItemInfoWidth+'px'}"><p class="product-name">莫尔根海鲜自助火锅</p> 
                  <div class="saleinfo">
                    <p class="price"><i class="fa fa-rmb"></i>53.9 <i style="font-size: 12px;color:#ccc;text-decoration:line-through;"><i class="fa fa-rmb" style="font-size:12px; margin:0px;"></i>69</i></p>
                    <p class="saleCount"><span style="color: #ccc;font-size:12px;">已售2331</span></p>
                  </div>
                </div>
              </router-link>
            </div>
        </mu-list-item> -->
      </mu-list>   
      <mu-list>
        <mu-list-item style="border-bottom: 1px solid #f5f5f5;">
           <div class="dinwei">
            <p>
              <mu-icon  value=":fa fa-mydinwei" :size="16" style="color: #666;"/>
              <router-link :to="'/shangquan/shopMap?latitude='+storeInfo.Latitude+'&longitude='+storeInfo.Longitude">
                <span style="padding-left:5px; color: #999;">{{storeInfo.ShopAddress}}</span>
              </router-link>
            </p>  
          </div>   
        </mu-list-item>    
        <mu-list-item  class="address">
          <p class="telePhone">
            <mu-icon  value=":fa fa-telephone" :size="20" style="color: #666;width:14px;" />
            <span style="padding-left:5px; color: #999;">{{storeInfo.ContactPhone}}</span>
          </p>
         
          <div class="phone1">
            <a :href="'tel://'+storeInfo.ContactPhone"><mu-icon  value=":fa fa-phone1" :size="26" color="rgb(244, 67, 54)" /></a>
          </div>
        </mu-list-item>
      </mu-list>
      <div>
        <div>
          <mu-tabs :value="activeTab" @change="handleTabChange">
            <mu-tab value="tab1" title="商家介绍"/>
            <mu-tab value="tab2" title="评论"/>
          </mu-tabs>
          <div v-if="activeTab === 'tab1'">
            <mu-list class="pinlun">      
              <div class="introduce">
                <div class="intro" v-html="storeInfo.ShopIntroduced"></div>   
              </div>
            </mu-list>
          </div>
          <div v-if="activeTab === 'tab2'">
            <div class="pinglun">      
              <mu-list-item>          
                <span style="color: #999;">评论{{evaluateCount}}</span>
                <span style="float:right; width: 50%; text-align: right;">
                  <mu-icon value=":fa fa-star" color="rgb(244, 67, 54)" :size="16" slot="left" v-for="eIndex in evaluateAvaStarLevel" :key="eIndex" />
                  <mu-icon value=":fa fa-star" color="#ccc" :size="16" slot="left" v-for="eIndex in (5-evaluateAvaStarLevel)" :key="eIndex" />
                  <p style="padding-left: 3%; color: rgb(244, 67, 54); font-size: 14px;float:right;">{{evaluateAvaStarLevel}}分</p>
                </span>
              </mu-list-item>  
              <mu-divider shallowInset/> 
              <div class="id-sumary">
                <ul v-if="evaluateList">
                  <li v-for="evaluateItem in evaluateList" :key="evaluateItem.ShopId">              
                    <div  class="timg" :style="{height: timgHeight +'px'}">
                      <img :src="evaluateItem.PjUserHeadPic" alt="">
                    </div> 
                    <span class="nametime">{{evaluateItem.PjUserName}}</span>
                    <span class="time">{{evaluateItem.PjDateName.split(' ')[0]}}</span>
                    <div class="xing-div">
                      <span class="fa fa-star" v-for="i in evaluateItem.StarLevel"></span>
                      <span class="fa fa-star unStar" v-for="i in (5-evaluateItem.StarLevel)"></span>
                    </div>
                    <p class="content">{{evaluateItem.PjContent}}</p>
                    <div class="pj-img-list">                
                      <div class="dimg" :style="{height:dimgWidth+'px'}" v-for="imgItem in evaluateItem.Images" :key="imgItem.Id" >
                        <img :src="imgItem.ImgPath" @click="goToEvaluateImg(evaluateItem.ShopId,imgItem.Id)" />
                      </div> 
                    </div>
                    <template v-if="evaluateItem.HfUserName">              
                      <span class="nametime" style="margin-top:10px;">
                        <span><img style="width: 27px;height: 27px;border-radius: 50%;margin-right: 10px;" src="http://imgserver.xurigo.com/upload/images/product/2018/12/17/1353477496bac4-a399-484b-9157-e6e79c522b81.jpg" alt=""></span>
                      <span style="color: red;">{{evaluateItem.HfDateName.split(' ')[0]}} 商家回复：</span>{{evaluateItem.HfUserName}} </span>
                      <p class="content">{{evaluateItem.HfContent}}</p>
                    </template>
                    <mu-divider />
                  </li>
                  <li v-if="evaluateCount<=5" style="text-align:center; font-size:12px; color:#999;">暂无更多</li>
                </ul>
              </div>
              <mu-list-item v-if="evaluateCount>5" title="查看全部" class="list1" :to="'/shangquan/pingjiaEvaluate?shopId='+storeInfo.ShopId">
                <mu-icon slot="right" value=":fa fa-angle-right" :size="20" color="#999"/> 
              </mu-list-item>
            </div>
          </div>
        </div>
      </div>   
      
      <!-- <mu-list class="tuijian">
        <mu-list-item>
          <span style="color:#999">推荐菜</span>
          <mu-icon value=":fa fa-angle-right" :size="20" color="#999" slot="right"/>    
        </mu-list-item>
        <mu-divider shallowInset/>  
        <mu-list-item class="caiming">
          <span>推荐菜</span> <span>烧鹅</span> <span>烧鸭</span> 
          <span>推荐菜</span> <span>烧鹅</span> <span>烧鸭</span>           
          <span>推荐菜</span> <span>烧鹅</span> <span>烧鸭</span>
          <span>推荐菜</span> <span>烧鹅</span> <span>烧鸭</span>
          <span>推荐菜</span> <span>烧鹅</span> <span>烧鸭</span> 
          <span>推荐菜</span> <span>烧鹅</span> <span>烧鸭</span>           
          <span>推荐菜</span> <span>烧鹅</span> <span>烧鸭</span>
          <span>推荐菜</span> <span>烧鹅</span> <span>烧鸭</span>
        </mu-list-item>     
      </mu-list> -->
      
    <mu-list style="margin-bottom: 48px;">
      <div class="proList" style="line-height: 40px;overflow: hidden;padding: 0 10px;">
        <mu-icon style="float: left;margin-top: 10px;" value=":fa fa-xingxing " color="red"/>
          <p style="line-height: 40px; float: left;font-weight: bold;font-size: 15px;margin-left: 5px;">店铺推荐</p>
      </div>
      <mu-list-item class="proList" v-for="storeItem in storeList" :key="storeItem.ShopId">            
          <div class="product-item" @click="GoShop(storeItem.ShopId)">
            <img :src="storeItem.Image" class="pro-img"> 
            
            <div class="product-info" :style="{ width:proItemInfoWidth+'px'}">
                <div style="overflow: auto;">
                  <p class="store_name">{{storeItem.CompanyName}} </p>
                 
                </div>
                <p class="fiveStar">
                  <mu-icon value=":fa fa-star"  slot="left" v-for="xj in storeItem.XingJi" :key="xj" />
                  <mu-icon value=":fa fa-star" class="empty_satr" slot="left" v-for="xj in (5-storeItem.XingJi)" :key="xj" />
                  <span style="padding-left: 3%; color: rgb(244, 67, 54); font-size: 14px; width:15%;">{{storeItem.XingJi}}分</span>
                  <span class="distance">{{storeItem.Distance>1000? (storeItem.Distance/1000).toFixed(1)+'km':storeItem.Distance+'m'}}</span>
                </p>
              <div class="active" :style="{width:proItemInfoWidth+'px'}">
                <p class="fontIcon wua">{{storeItem.ShopManagement&&storeItem.ShopManagement.length>20?storeItem.ShopManagement.substr(0,26):storeItem.ShopManagement}}</p>
              </div> 
                <div class="saleinfo">          
                  <div class="saleCount">      
                    <p class="per_capita">人均<span style="font-size:12px;color:red; ">￥</span><span style="color:red; font-weight:bold;font-size:17px;">{{storeItem.AverageConsumption}}</span></p>  
                    <span style="float:right;color: #666;">已售{{storeItem.SaleCount}}</span>
                  </div>
                  <p class="price" v-if="storeItem.IsDiscount==1">{{storeItem.SaleDiscount}}折</p>
                  <p class="price" v-if="storeItem.IsDiscount==2">BAW</p>
                </div>
              </div>
            </div>
      </mu-list-item>
    </mu-list>
    <mu-list class="bottomNav">        
      <mu-list-item class="maidan">
          <span style="color:red;font-size: 20px; width: 80%;">{{storeInfo.IsDiscount==1?storeInfo.SaleDiscount+'折':""}}</span>
          <div class="you" style="display: flex;">        
            <mu-raised-button  label="优惠买单" class="submit" :to="'/shangquan/maidan?shopId='+storeInfo.ShopId"  />
          </div>
      </mu-list-item>
    </mu-list>
    <XR-toast ref="XRtoast"></XR-toast>
   </div>
</template>
<script>
export default {
  data() {
    return {
      proItemInfoWidth: (parseInt(document.documentElement.clientWidth)-135),      
      dimgWidth : (document.documentElement.clientWidth-16)*0.32,
      timgHeight:  (document.documentElement.clientWidth-16)*0.09,
      show:false,
      shopId: '',
      storeInfo:{
        CompanyName:''
      },
      evaluateList:[], 
      evaluateCount:0,   
      evaluateAvaStarLevel:5.0,  
      storeList:[],
      favState: false,
      cityCode:'',
      lng:window.localStorage.UserLocationLng,
      lat:window.localStorage.UserLocationLat,
      activeTab: 'tab1'
    }
  },
  mounted() {
     this.cityCode = window.localStorage.ProductDetailDeliveryCityCache
     if(!this.cityCode){
       this.cityCode = ''
     }
     this.shopId= this.$route.query.shopId
     this.GoShop(this.shopId)
  },
  methods: {
    handleTabChange (val) {
      this.activeTab = val
    },
    GoHistory(){
      this.$router.goBack()
    },
    GoShop(shopId){
      this.shopId = shopId
      this.getStoreInfo()
      this.getStorePage()
      this.GetFavState()
      this.$el.scrollTop=0
    },
    GetFavState(){  
      const ths = this;
      this.$post("/Shop/StoreServer/GetShopsFavorite", {'shopId':this.shopId , 'favType': 1})
      .then(function(res) {
        ths.favState = res.IsSuccess
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    FavStore(){  
      const ths = this;
      this.$post("/Shop/StoreServer/AddShopsFavorite", {'shopId':this.shopId , 'favType': 1})
      .then(function(res) {
        if (res.IsSuccess) {
          ths.favState = true
        }else{
          ths.$refs.XRtoast.failed(res.Msg, true)
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    UnFavStore(){  
      const ths = this;
      this.$post("/Shop/StoreServer/CancelShopsFavorite", {'shopIds':[this.shopId] , 'favType': 1})
      .then(function(res) {
        if (res.IsSuccess) {
          ths.favState = false
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    touchEvent(){
      var scrollTop = this.$el.scrollTop
      var opacityValue=this.$el.scrollTop/350

      document.querySelector('.xr-head').style.background='rgba('+this.themeColor+','+opacityValue+')'
    },
    getStoreInfo(){      
      const ths = this;
      this.$post("/Shop/StoreServer/GetShopsPhysicalStore", {'shopId':this.shopId})
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
          
          ths.storeInfo = res.Data
          ths.storeInfo.ShopIntroduced = decodeURIComponent(ths.storeInfo.ShopIntroduced)
          
          ths.getEvaluatePage()
          //ths.$refs.XRtoast.hide();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getEvaluatePage(){      
      const ths = this;
      this.$post("/Shop/StoreServer/GetShopsPhysicalEvaluatePage", {'shopId':this.shopId, 'pageIndex':1,'pageSize':5})
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
          
          ths.evaluateList = res.Data.List
          ths.evaluateCount = res.Data.Rows
          ths.evaluateAvaStarLevel = res.Data.otherEntity
          
          //ths.$refs.XRtoast.hide();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getStorePage(){
      const ths = this;this.$post("/Shop/StoreServer/GetShopsPhysicalStorePage", {
        'searchName': this.searchName
        ,'areaId':this.cityCode
        , 'pageIndex':1
        , 'pageSize':3
        , 'longitude':this.lng
        , 'latitude':this.lat
        , 'sort': 'distance'
      })
      .then(function(res) {
        if (res.IsSuccess) {
          ths.loaded = false;
          
          ths.storeList = res.Data.List

          //ths.$refs.XRtoast.hide();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },    
    goToEvaluateImg(shopId, imgId){
      this.$router.push('/shangquan/pingjiaImg?shopId='+shopId + '&imgId='+imgId)
    }
  },
  computed: {
    pageKey() {
        return this.$route.name !== undefined? this.$route.name +new Date(): this.$route +new Date()
    }
  }
};
</script>
<style>
.shangquanpingjiaPage .xr-mingxi .mu-appbar{
  background-color: #fff;
  color: #000;
  background: rgba(71, 74, 79,0);
  position: fixed;
  top: 0;
  box-shadow: none;
  z-index: 1000;
}
.shangquanpingjiaPage .xr-mingxi .xr-head .mu-icon{
  color: #fff;
  border-radius: 50%;
  background: rgba(71,74,79,0.3);
  width: 30px;
  height: 30px;
}
.shangquanpingjiaPage .xr-mingxi .xr-head .left .fa-angle-left{
  padding-top: 2px;
}
.shangquanpingjiaPage .xr-mingxi .xr-head .fa-xing1{
  font-size: 24px;
  margin-right: 5px;
  padding-bottom: 5px;
  color:#fff;
  height: 30px;
  line-height: 30px;
}
.shangquanpingjiaPage .xr-mingxi .xr-head .fa-star{
  font-size: 24px;
  width: 30px;
  margin-right: 5px;
  padding-bottom: 5px;
  color:red;
  height: 30px;
  line-height: 30px;
}
.shangquanpingjiaPage .xr-mingxi .mu-icon-button{
  margin-bottom: 4px;
}
.shangquanpingjiaPage .productPingfen .productBanner{
  width: 100%;
  height: 230px;
  margin-bottom: 20px;
}
.shangquanpingjiaPage .productPingfen .productBanner .wh_content{
  height: 100%;
}
.shangquanpingjiaPage .xr-mingxi .mu-appbar-title {
    font-size: 16px;
    text-align: center;
    color: #fff;
    }
.shangquanpingjiaPage .xr-mingxi .title .mu-icon-button {
    position: absolute;
    left: 0;
    top: 0;
    color:white;
    }
.shangquanpingjiaPage .xr-mingxi .title .title-text {
    margin: 0;
    line-height: 48px;
    }
.shangquanpingjiaPage .proList{
    border-bottom: 1px solid #f5f5f5;
}
.shangquanpingjiaPage .productPingfen .proList{
  padding: 0 5%;
}
.shangquanpingjiaPage .productPingfen .proList .storeName{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.shangquanpingjiaPage .xr-mingxi .right{
    margin: 0 8px;
    font-size: 16px
}
.shangquanpingjiaPage .xr-mingxi .right a{
    color: #fff;
}
.shangquanpingjiaPage .productBanner img{
  width: 100%;
  height: 230px;
  object-fit: cover;
}
body .shangquanpingjiaPage .productPingfen{
  padding-top: 0;
  margin-top: 0;
  background: #fff;
}
.shangquanpingjiaPage .proList .fiveStar{
  align-items: center;
  display: flex;
  height: 28px;
  line-height: 28px;
}
.shangquanpingjiaPage .star-leval .pjPrice{
  color: #aaa;
  padding-left: 5%;
  width:45%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.shangquanpingjiaPage .proList .fiveStar .fa-star{
  font-size: 12px;
  width: 12px;
  height: 12px;
  color: orange;
}
.shangquanpingjiaPage .proList .star-leval .fiveStar .fa-star{
  font-size: 12px;
  width: 12px;
  height: 12px;
  color: orange;
}
.shangquanpingjiaPage .proList .fiveStar .fa-star.empty_satr{
  font-size: 12px;
  width: 12px;
  height: 12px;
  color: #ccc;
}
.shangquanpingjiaPage .proList .mu-item-title,.shangquanpingjiaPage .love .proList1 .mu-item-title{
  font-size: 15px;
  font-weight: bold;
}
.shangquanpingjiaPage .productPingfen .mu-item{
  padding: 0px 16px;
}
.shangquanpingjiaPage .duce .mu-item-content{
  display: flex;
}
.shangquanpingjiaPage .duce .zuo{
  width: 100%;
  padding:8px 5%;
}
.shangquanpingjiaPage .duce .zuo .img_pro{
  height:25px;
  display:flex;
  align-items: center;
  line-height: 25px;
  font-size:12px;
  width: 33%;
  float: left;
  
}
.shangquanpingjiaPage .duce .zuo .img_pro .pro_server{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-left: 5px;
  color: #999;
  width: 80%;
}
.shangquanpingjiaPage .duce .serviceImg{
  width: 20px;
  height: 20px;
}
.shangquanpingjiaPage .duce .you{
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.shangquanpingjiaPage .duce .you .mu-raised-button{
  height: 30px;
  background: rgb(244, 67, 54);
  color: #fff;
  min-width: 100%;
}
.shangquanpingjiaPage .duce .you .mu-raised-button .mu-raised-button-label{
  padding: 0;
}
.shangquanpingjiaPage .love{
  background: #fff;
  margin-top: 10px;
}
.shangquanpingjiaPage .love .proList1{
  margin-bottom: 5px;
}
.shangquanpingjiaPage .love .proList1 .mu-item.show-left{
  padding-left: 42px;
}
.shangquanpingjiaPage .address .mu-item .mu-item-content{
  display: flex;
}
.shangquanpingjiaPage  .mu-item .dinwei{
  padding: 0 16px;
}
.shangquanpingjiaPage  .mu-item .dinwei p{
  height: 25px;
  line-height: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
}
.shangquanpingjiaPage .address{
  padding: 0 16px;
}
.shangquanpingjiaPage .address .telePhone{
  width: 75%;
  line-height: 36px;
  border-right: 1px solid #f5f5f5;
  display: flex;
  align-items: center;
}

.shangquanpingjiaPage .address .mu-item .phone1{
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.shangquanpingjiaPage .tmbtn .mu-item{
  padding: 0;
  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
}
.shangquanpingjiaPage  .tmbtn .mu-flat-button-label{
  color: rgb(244, 67, 54);
  font-size: 16px;
  padding: 0px;
}
.shangquanpingjiaPage  .tmbtn .fa-angle-down,.shangquanpingjiaPage .tmbtn .fa-angle-up{
  color: rgb(244, 67, 54);
  font-size: 18px;
}
.shangquanpingjiaPage .zhekou {
  padding-left: 5%;
}
.shangquanpingjiaPage .zhekou .sale_circle{
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 50%;
  background: #ff4981;
  background: url(' ../../../static/shangquan/te.png');
  background-size: 100% 100%;
  float: left;
  color: #fff;
  text-align: center;
  font-size: 12px;
}
.shangquanpingjiaPage .zhekou .mu-item {
  border-bottom: 1px solid #f5f5f5;
}
.shangquanpingjiaPage .zhekou .mu-item .mu-item-content{
  display: flex;
}
.shangquanpingjiaPage .proList .mu-item .temai{
  display: flex;
  align-items: center;
}
.shangquanpingjiaPage .product-item ~ .product-item{
  border-top:1px solid #eee;
}
.shangquanpingjiaPage .product-item a{  
  color:black;
}
.shangquanpingjiaPage .product-item .pro-img{
  float: left;
  background: white;
  max-height: 90px;
}
.shangquanpingjiaPage .product-item .product-info{
  float: left;
  padding: 1px;
  margin-left: 10px;
  word-break: break-all;
}

.shangquanpingjiaPage .product-item  .product-info .product-name{
  overflow:hidden;
  line-height: 16px;
  height: 16px;
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.shangquanpingjiaPage .introduce .intro{
 padding: 0 16px;
}
.shangquanpingjiaPage .introduce .intro p img{
  width: 17%;
  height: 60px;
  object-fit: cover;
  margin-bottom: 10px;
  margin-right: 3%;
}
.shangquanpingjiaPage .product-item .product-info .active{
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.shangquanpingjiaPage .product-item  .product-info .active .fontIcon{
  float: left;
  font-size: 12px;
  color:#666;
  border-radius: 2px;
  line-height: 14px;
  margin: 6px 1px;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.shangquanpingjiaPage .product-item  .saleinfo{
  overflow: hidden;
  line-height: 16px;
  font-size: 12px;
}
.shangquanpingjiaPage .product-item  .product-info .price{
  font-size: 12px;
  width: 50px;
  color: Red;
  padding: 2px 5px;
  text-align: center;
  border: 1px solid #f5c3c3;
  border-radius: 3px;
  margin-top: 5px;
}
.shangquanpingjiaPage .product-item  .product-info .saleinfo .price .fa{
  font-size: 14px;
  margin-right: 5px;
}
.shangquanpingjiaPage .product-item  .product-info .saleinfo .saleCount{
  color: rgb(170, 170, 170);
  text-align: right;
  overflow: auto
}
.shangquanpingjiaPage .product-item  .product-info .saleinfo .saleCount .per_capita{
  width: 60%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-align: left;
  float: left;
}
.shangquanpingjiaPage .tuijian{
  margin-top: 10px;
  padding:16px 16px;
  background: #fff;
}
.shangquanpingjiaPage .tuijian .mu-item-right{
  right: 0px;
}
.shangquanpingjiaPage .tuijian .mu-item {
  padding: 0; 
}
.shangquanpingjiaPage .tuijian .caiming{
  margin-top: 10px;
}
.shangquanpingjiaPage .tuijian .caiming .mu-item-content span{
  padding-right: 15px;
}
.shangquanpingjiaPage .pinglun{
  background: #fff;
  margin-top: 0;
}
.shangquanpingjiaPage .mu-tabs{
  margin-top: 10px;
}
.shangquanpingjiaPage .pinglun .list1 .mu-item-title{
  font-size: 14px;
  color: rgb(244, 67, 54);
}
.shangquanpingjiaPage .prolist2{
  background: #fff;
  margin-top: 10px;
  padding-bottom: 0;
}
.shangquanpingjiaPage .prolist2 .mu-item-title{
  font-size: 14px;
  color: #999;
}
.shangquanpingjiaPage .prolist2 .product-item .saleinfo {
    overflow: hidden;
    font-size: 12px;
    margin-top: 0px;
}


body .shangquanpingjiaPage .bottomNav{
 padding: 0;
 position: fixed;
 bottom: 0;
 z-index: 10;
}
.shangquanpingjiaPage .bottomNav .maidan .mu-item-content{
  display: flex;
  align-items: center;
  height: 48px;
}
.shangquanpingjiaPage .bottomNav .maidan .mu-item{
  box-shadow: 0px -2px 10px 0px #ccc;
  padding:  0 16px;
}

.shangquanpingjiaPage .maidan .submit{
  background: rgb(244, 67, 54);
  color: #fff;
  height: 48px;
}

.shangquanpingjiaPage .id-sumary{
  background: white;
}
.shangquanpingjiaPage .id-sumary ul li{
  padding:1rem 0.5rem;
  list-style: none;
}
.shangquanpingjiaPage .id-sumary ul li .mu-divider{
  background-color: #f5f5f5; 
}
.shangquanpingjiaPage .id-sumary ul li .timg{
  width: 9%;
  float: left;
  display:flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 10px;
}
.shangquanpingjiaPage .id-sumary ul li .timg img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.shangquanpingjiaPage .id-sumary ul li:last-child{
  box-shadow:none;
}
.shangquanpingjiaPage .id-sumary ul li .nametime{
  display: block;
  color:#000;
  font-size: .75rem;
  display: flex;
  align-items: center;
}
.shangquanpingjiaPage .id-sumary ul li .time{
  float: right;
  color: #999;
  font-size: 12px;
}
.shangquanpingjiaPage .id-sumary ul li p{
  color:#5A5655;
  font-size:14px;
  line-height: 1.4;
}
.shangquanpingjiaPage .id-sumary ul li p.content{
  clear:both;
  margin-top: 10px;
}
.shangquanpingjiaPage .id-sumary ul li p.content img
{
    width:50px;
    height:50px;
}
.shangquanpingjiaPage .id-sumary ul li .pj-img-list{
  overflow: hidden;
}
.shangquanpingjiaPage .id-sumary ul li .pj-img-list .dimg
{
  float: left;
  overflow: hidden;
  width:32%;
  margin-top: 8px;
  display:flex;
  align-items: center;
  justify-content: center;

}
.shangquanpingjiaPage .id-sumary ul li .pj-img-list .dimg:nth-child(n+2){
  margin-left: 2%;
}
.shangquanpingjiaPage .id-sumary ul li .pj-img-list .dimg:nth-child(4){
  margin: 0;
  margin-top: 8px;
}
.shangquanpingjiaPage .id-sumary ul li .pj-img-list .dimg img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.shangquanpingjiaPage .id-sumary .id-comments-dd{
  display: none;
  font-size: .75rem;
  line-height: 2;
  color:#5A5655;
}
.shangquanpingjiaPage .id-sumary .id-comments-dd:nth-child(2){
  display: block;
}

.shangquanpingjiaPage .xing-div
{
  height:18px;
  overflow:hidden;
  font-size: 12px;
  display: flex;
}
.shangquanpingjiaPage .xing-div .fa-star{
  color:red;
}
.shangquanpingjiaPage .xing-div .fa-star.unStar{
  color:#ccc;
}

.shangquanpingjiaPage .mu-list{
  background: #fff;
  padding: 0;
  margin-top: 10px;
}
.shangquanpingjiaPage .mu-list.love{
  margin: 0;
  margin-top: 10px;
}
.shangquanpingjiaPage .mu-list .mu-item{
  padding: 0px;
}
.shangquanpingjiaPage .mu-item.show-left{
  padding-left: 45px;
  
}
.shangquanpingjiaPage .mu-list .proList{
  border-bottom: 1px solid #f5f5f5;
}
.shangquanpingjiaPage .mu-list .proList:last-child{
  border: none;
}
.shangquanpingjiaPage .mu-list .proList2{
  border: 0;
}
.shangquanpingjiaPage .mu-list .fa-xingxing{
  font-size: 20px;
}
.shangquanpingjiaPage .proList .demo-flat-button .mu-flat-button-wrapper .mu-flat-button-label{
  font-size: 14px;
  padding: 0px;
}
.shangquanpingjiaPage .proList .demo-flat-button .mu-flat-button-wrapper .fa-angle-right{
  font-size: 16px;
  color: #ccc;
}
.shangquanpingjiaPage .proList .demo-flat-button .mu-flat-button-wrapper{
  padding-right: 16px;
}


.shangquanpingjiaPage .product-list{
  overflow: hidden;
  margin-top: 5px;
  border-bottom:1px solid #eee;
  background: white;
}
.shangquanpingjiaPage .product-item{
  width:100%;
  overflow: hidden;
  padding: 10px;
}
.shangquanpingjiaPage .product-item ~ .product-item{
  border-top:1px solid #eee;
}
.shangquanpingjiaPage .product-item a{  
  color:black;
}
.shangquanpingjiaPage .product-item .pro-img{
  width: 95px;
  float: left;
  background: white;
  height: 95px;
  object-fit: cover;
}
.shangquanpingjiaPage .product-item .product-info{
  float: left;
  padding: 1px;
  margin-left: 10px;
  word-break: break-all;
}
.shangquanpingjiaPage .product-item  .product-info .product-name{
  overflow:hidden;
  line-height: 16px;
  height: 16px;
  font-size: 14px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.shangquanpingjiaPage .store_name{
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #474a4f;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.shangquanpingjiaPage  .distance{
    color: #666;
    text-align: right;
    float: right;
}
.shangquanpingjiaPage .mu-list.pinlun{
  margin: 0;
  padding: 10px 0;
}
</style>




// WEBPACK FOOTER //
// src/pages/shangquan/pingjia.vue